import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useAuth, useUser } from '@clerk/react';
import { lazy } from 'react';
import { LazyComponent as LazyWrapper } from '@/components/ui';

// Lazy load the ResetPasswordPage component
const ResetPasswordPage = lazy(() => import('../template/pages/reset-password-page'));

const AuthResetPasswordRoute = () => {
  // Check both hooks for maximum compatibility
  const { isLoaded: isUserLoaded, isSignedIn: isUserSignedIn } = useUser();
  const { isLoaded: isAuthLoaded, isSignedIn: isAuthSignedIn } = useAuth();

  // Wait for both to load
  const isLoaded = isUserLoaded && isAuthLoaded;
  const isSignedIn = isUserSignedIn || isAuthSignedIn;

  // Show loading state while Clerk is initializing
  if (!isLoaded) {
    return (
      <div className='min-h-screen flex items-center justify-center bg-background'>
        <div className='animate-spin h-10 w-10 rounded-full border-4 border-primary/30 border-t-primary' />
      </div>
    );
  }

  // If user is already authenticated, redirect to dashboard
  // This prevents authenticated users from accessing the reset password page
  if (isSignedIn) {
    return <Navigate to='/dashboard' replace />;
  }

  // User is not authenticated, show reset password page
  return (
    <LazyWrapper>
      <ResetPasswordPage />
    </LazyWrapper>
  );
};

export const Route = createFileRoute('/auth/reset-password')({
  loader: async () => {
    const { default: i18n } = await import('../i18n');
    await i18n.loadNamespaces?.(['auth']);
    return null;
  },
  component: AuthResetPasswordRoute,
});
